const specialKeyWords = [
    'stranger things',
    'La multi ani, Romania!',
    'La mulți ani, România!'
];

export function getMatchedKeyword(text) {
  if (!text) return null;

  const lower = text.toLowerCase();

  return (
    specialKeyWords.find((keyword) =>
      lower.includes(keyword.toLowerCase())
    ) || null
  );
}